<div style="max-height: 46vh; overflow-y: scroll;">
        <table #dataTable mat-table matSort [dataSource]="workloadData" class="mat-elevation-z1" style="overflow-y: auto;">
            <ng-container matColumnDef="selection">
                <th mat-header-cell *matHeaderCellDef style="width:55px" id="selectionHeader">
                </th>
                <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
                    <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(element) : null"
                    [checked]="selection.isSelected(element)"></mat-checkbox>
                </td>
            </ng-container>
            <ng-container matColumnDef="Team_Member">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Team Member</th>
                <td mat-cell *matCellDef="let element">
                    <div class="d-flex align-items-center">
                        <div class="user-availability {{ element.availableStatus }}">
                        </div>
                        <div class="d-flex flex-column">
                            <p class="username">{{ element.userName }}</p>
                            <p class="user-email">{{ element.email }}</p>
                        </div>
                    </div>
                </td>
            </ng-container>
    
            <ng-container matColumnDef="Cases">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Cases</th>
                <td mat-cell *matCellDef="let element">
                    <ng-container *ngIf="{
                        cases: isFiltered ? element.filteredCasesCount : element.casesAssigned.length,
                        pastDue: isFiltered ? element.filteredPastDue : element.pastDue,
                        dueToday: isFiltered ? element.filteredDueToday : element.dueToday,
                        dueTomorrow: isFiltered ? element.filteredDueTomorrow : element.dueTomorrow
                    } as counts">
                        <div class="d-flex align-items-center" style="gap: 8px" *ngIf="counts.cases > 0">
                            <span style="white-space: nowrap; width: 90px">{{ counts.cases + ' assigned' }}</span>
                            <mat-chip-set>
                                <mat-chip class="circle-chip pastDue">{{ counts.pastDue }}</mat-chip>
                                <mat-chip class="circle-chip dueToday">{{ counts.dueToday }}</mat-chip>
                                <mat-chip class="circle-chip dueTomorrow">{{ counts.dueTomorrow }}</mat-chip>
                            </mat-chip-set>
                        </div>
                    </ng-container>
                </td>
            </ng-container>

            <ng-container matColumnDef="Tasks">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Tasks</th>
                <td mat-cell *matCellDef="let element">
                    <ng-container *ngIf="{
                        tasks: isFiltered ? element.filteredTasksCount : element.tasksAssigned.length,
                        pastDue: isFiltered ? element.filteredTasksPastDue : element.tasksPastDue,
                        dueToday: isFiltered ? element.filteredTasksDueToday : element.tasksDueToday,
                        dueTomorrow: isFiltered ? element.filteredTasksDueTomorrow : element.tasksDueTomorrow
                    } as taskCounts">
                        <div class="d-flex align-items-center" style="gap: 8px" *ngIf="taskCounts.tasks > 0">
                            <span style="white-space: nowrap; width: 90px">{{ taskCounts.tasks + ' assigned' }}</span>
                            <mat-chip-set>
                                <mat-chip class="circle-chip pastDue">{{ taskCounts.pastDue }}</mat-chip>
                                <mat-chip class="circle-chip dueToday">{{ taskCounts.dueToday }}</mat-chip>
                                <mat-chip class="circle-chip dueTomorrow">{{ taskCounts.dueTomorrow }}</mat-chip>
                            </mat-chip-set>
                        </div>
                    </ng-container>
                </td>
            </ng-container>

    
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <div *ngIf="workloadData.filteredData == null || workloadData.filteredData.length == 0" class="bg-white">
            <div class="p-4 text-center text-muted ">
                <img src="./assets/images/no-data-placeholder.png " alt=" " class="pb-3 " />
                <h6>No Team Members Found</h6>
            </div>
        </div>
    </div>
    <div class="flex align-items-center">
        <div id="actionButtons" *ngIf="selection.selected.length > 0" class="flex">
            <mat-chip-set>
                <mat-chip>{{selection.selected.length}} selected</mat-chip>
            </mat-chip-set>
        </div>
        <div style="margin-left: auto">
            <mat-paginator
                #paginator
                *ngIf="workloadData?.data?.length > 0"
                [length]="workloadData?.data?.length || 0"
                [pageIndex]="0"
                [pageSize]="10"
                appearance="fill"
                [pageSizeOptions]="[10, 25, 50, 100]"
            >
            </mat-paginator>
        </div>
    </div>